import { render, staticRenderFns } from "./LongServiceLeaveReport.vue?vue&type=template&id=d2599e00"
import script from "./LongServiceLeaveReport.vue?vue&type=script&lang=js"
export * from "./LongServiceLeaveReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports